export default function truncate(str: string, max = 160) {
  if (str.length <= max) return str.replace(/\n/g, ' ')
  const truncated = str.slice(0, max)
  const lastSentenceEnd = truncated.lastIndexOf('.')
  return truncated.slice(0, lastSentenceEnd + 1).replace(/\n/g, ' ')
}
